import React from 'react'

import Root from '../layout/root'

const wrapRootElement = ({element}) => <Root>{element}</Root>

export default wrapRootElement
